import api from "../axios";

/*
|--------------------------------------------------------------------------
| PUBLIC QUERY
|--------------------------------------------------------------------------
| Anyone can submit a query.
| NO AUTH TOKEN REQUIRED.
|
| POST /api/queries
|--------------------------------------------------------------------------
*/

export const createQueryApi = async (data) => {
  const response = await api.post(
    "/queries",
    data
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| ADMIN / STAFF - LIST QUERIES
|--------------------------------------------------------------------------
|
| GET /api/queries
|
| Supported filters:
| - status
| - clientId
| - offeringId
| - assignedTo
| - page
| - limit
|--------------------------------------------------------------------------
*/

export const getQueriesApi = async ({
  status = null,
  clientId = null,
  offeringId = null,
  assignedTo = null,
  page = 1,
  limit = 20
} = {}) => {

  const params = {
    page,
    limit
  };

  if (status) {
    params.status = status;
  }

  if (clientId) {
    params.clientId = clientId;
  }

  if (offeringId) {
    params.offeringId = offeringId;
  }

  if (assignedTo) {
    params.assignedTo = assignedTo;
  }

  const response = await api.get(
    "/queries",
    {
      params
    }
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| ADMIN / STAFF - GET SINGLE QUERY
|--------------------------------------------------------------------------
|
| GET /api/queries/:id
|--------------------------------------------------------------------------
*/

export const getQueryApi = async (id) => {
  const response = await api.get(
    `/queries/${id}`
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| ADMIN / STAFF - UPDATE QUERY
|--------------------------------------------------------------------------
|
| PATCH /api/queries/:id
|
| Possible fields:
| - offeringId
| - pricingPlanId
| - subject
| - message
| - status
| - assignedTo
|--------------------------------------------------------------------------
*/

export const updateQueryApi = async (
  id,
  data
) => {
  const response = await api.patch(
    `/queries/${id}`,
    data
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| ADMIN ONLY - DELETE QUERY
|--------------------------------------------------------------------------
|
| DELETE /api/queries/:id
|--------------------------------------------------------------------------
*/

export const deleteQueryApi = async (id) => {
  const response = await api.delete(
    `/queries/${id}`
  );

  return response.data;
};